import React from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateDiffContextDisplay } from '../actions/actionCreator';

const mapStateToProps = (state) => ({
  showDiffContext: state.diffContextDisplay,
});

const mapDispatchToProps = (dispatch) => ({
  updateDiffContextDisplayMapped: (e) => dispatch(updateDiffContextDisplay(e)),
});

class ContextToggle extends React.Component {
  toggleContext() {
    this.props.updateDiffContextDisplayMapped(!this.props.showDiffContext);
  }

  render() {
    return (
      <Form className="context-toggle">
        <Form.Group>
          <Form.Check
            type="checkbox"
            id="diff-context-checkbox"
            label="Show Diff Context"
            checked={this.props.showDiffContext}
            readOnly
            onChange={() => this.toggleContext()}
          />
        </Form.Group>
      </Form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContextToggle);
